import { render } from "./MetadataTree.vue?vue&type=template&id=a89ea194&scoped=true"
import script from "./MetadataTree.vue?vue&type=script&lang=js"
export * from "./MetadataTree.vue?vue&type=script&lang=js"

import "./MetadataTree.vue?vue&type=style&index=0&id=a89ea194&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89ea194"]])

export default __exports__